export const devices = {
    mobile: `(min-width: 576px)`,
    tablet: `(min-width: 768px)`,
    laptop: `(min-width: 992px)`
};
